<script>
import { gsap } from 'gsap'
import { mapState } from 'vuex'

export default {
    name: 'SlideProgress',
    props: {
        moduleType: {
            type: String,
            required: true
        },
    },
    computed: mapState({
        slides(state, getters) {
            return getters[`${this.moduleType}/slides`]
        },
        currentSlide(state, getters) {
            return getters[`${this.moduleType}/currentSlide`]
        },
    }),
    watch: {
        currentSlide() {
            gsap.to(this.$refs['progress'], {
                duration: 1.6,
                scaleX: this.currentSlide / (this.slides.length - 1),
                ease: 'expo.inOut'
            })
        }
    },
    mounted() {
        gsap.set(this.$refs['progress'], { scaleX: 0 } )
    },
    render: h => h(
        'div', {
            class: 'slide__progress'
        },
        [h('span', {
            ref: 'progress'
        })]
    )
}
</script>
